export const marketplace = {
  marketplaceSearchInputPlaceholderTitle: 'Поиск',
  marketplaceDetailsCurtainCopyOptionTitle: 'Скопировать ссылку',
  marketplaceDetailsCurtainFlagOptionTitle: 'Пожаловаться на контент',
  marketplaceDetailsCurtainCopiedAlertText: 'Ссылка скопирована!',
  marketplaceDetailsFlagCurtainTitle: 'Пожаловаться',
  marketplaceReportedCurtainContent: 'Жалоба отправлена',
  marketplaceAllItems: 'Все товары',
  marketplaceWantToBuy: 'Хочу купить {item} из {appname}'
}
